import { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { navLinks, company } from '../mock';
import { Button } from './ui/button';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/90 backdrop-blur-md border-b border-stone-200 shadow-[0_2px_24px_-12px_rgba(0,0,0,0.15)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-[72px] flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2.5 group">
          <div className="h-10 w-10 rounded-xl bg-[#0b6b5b] flex items-center justify-center text-white font-display font-bold text-base shadow-sm group-hover:rotate-3 transition-transform leading-none">
            <span>A</span><span className="text-[#f3c14a]">A</span>
          </div>
          <div className="leading-tight">
            <div className="font-display font-semibold text-[17px] text-stone-900">
              {company.name}
            </div>
            <div className="text-[11px] tracking-wider uppercase text-stone-500">
              {company.region}
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="soft-link text-[14.5px] font-medium text-stone-700 hover:text-[#0b6b5b]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${company.phone.replace(/\s/g, '')}`}
            className="flex items-center gap-2 text-sm font-medium text-stone-700 hover:text-[#0b6b5b]"
          >
            <Phone className="h-4 w-4 text-[#0b6b5b]" />
            {company.phone}
          </a>
          <Button asChild className="brand-btn rounded-full px-5 h-10 font-semibold">
            <a href="#contact">Free Consult</a>
          </Button>
        </div>

        <button
          aria-label="Open menu"
          className="lg:hidden h-10 w-10 grid place-items-center rounded-lg border border-stone-300 bg-white"
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      <div
        className={`lg:hidden bg-white border-b border-stone-200 mobile-nav-enter ${
          open ? 'mobile-nav-open' : ''
        }`}
      >
        <div className="px-5 py-4 flex flex-col gap-3">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="py-2 text-stone-800 font-medium border-b border-stone-100"
            >
              {l.label}
            </a>
          ))}
          <a
            href={`tel:${company.phone.replace(/\s/g, '')}`}
            className="flex items-center gap-2 mt-1 text-stone-700"
          >
            <Phone className="h-4 w-4 text-[#0b6b5b]" />
            {company.phone}
          </a>
          <Button asChild className="brand-btn rounded-full h-11 font-semibold">
            <a href="#contact" onClick={() => setOpen(false)}>Free Consult</a>
          </Button>
        </div>
      </div>
    </header>
  );
}
